<template>
  <div class="mask-layer" v-if="show">
    <div class="modal">
      <div class="shut-down" @click="onShutdown"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
      show: {
          type: Boolean,
          default: false
      }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
      onShutdown() {
          this.$emit('shutdown')
      }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.mask-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  .modal {
    width: rem(620);
    padding: rem(60) 0;
    border-radius: rem(10);
    background: #fff;
    position: absolute;
    top: rem(268);
    left: 50%;
    transform: translateX(-50%);
    .shut-down {
      width: rem(32);
      height: rem(32);
      background: url("./images/shut_down.png") no-repeat;
      background-size: rem(32) rem(32);
      position: absolute;
      top: rem(20);
      right: rem(20);
    }
  }
}
</style>
